// Role helpers for the admin portal. Phase Administrators are scoped to their phase(s) and the
// backend rejects estate-level endpoints for them, so the UI hides those pages and controls.
const SESSION_KEY = "zangon_session";

function getSession() {
  try {
    return JSON.parse(localStorage.getItem(SESSION_KEY) || "null");
  } catch {
    return null;
  }
}

function getJwtRoles(token) {
  try {
    const part = String(token).split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const claims = JSON.parse(atob(part));
    return Object.keys(claims)
      .filter((k) => /role|usertype/i.test(k))
      .map((k) => claims[k]);
  } catch {
    return [];
  }
}

// Every role/usertype value on the session payload and the access-token claims, flattened to strings.
export function getAdminRoles() {
  const session = getSession();
  if (!session) return [];
  return [session.role, session.roles, session.userType, getJwtRoles(session.accessToken)]
    .flat(Infinity)
    .filter((r) => typeof r === "string" && r)
    .map((r) => r.trim());
}

// TODO: the exact claim value is unconfirmed; this matches "PhaseAdministrator", "Phase Admin", "phase_admin", etc.
export function isPhaseAdmin() {
  return getAdminRoles().some((r) => /phase/i.test(r));
}
